import ProviderAPI from "../redux/ProviderAPI";

export const login = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/login",
    data: data,
  });

  return result;
};

export const register = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/register",
    data: data,
  });

  return result;
};

export const detailUser = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/authprofile/detailUser",
    data: data,
    headers: data.token,
  });

  return result;
};

export const editUser = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/editUser",
    data: data.dataForm,
    headers: data.token,
  });

  return result;
};

export const sendEmailForgetPassword = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/sendEmailForgetPassword",
    data: data,
  });

  return result;
};

export const resetPassword = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/resetPassword",
    data: data,
  });

  return result;
};

export const changePassword = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/changePassword",
    data: data,
  });

  return result;
};

export const sendEmail = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/sendEmail",
    data: data,
  });

  return result;
};

export const sendEmailBooking = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/sendEmailBooking",
    data: data,
  });

  return result;
};

export const sendRefundRequestEmail = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/sendRefundRequestEmail",
    data: data,
  });

  return result;
};

export const sendEmailBookings = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/sendEmailBookings",
    data: data,
  });

  return result;
};

export const becomePartner = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/becomePartner",
    data: data,
  });

  return result;
};

export const getCookiepolicy = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/authprofile/getCookiepolicy",
    data: data,
  });

  return result;
};

export const getGuidelines = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/authprofile/getGuidelines",
    data: data,
  });

  return result;
};

export const getRefundpolicy = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/authprofile/getRefundpolicy",
    data: data,
  });

  return result;
};

export const getTerms = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/authprofile/getTerms",
    data: data,
  });

  return result;
};

export const getPrivacypolicy = async (data) => {
  const result = await ProviderAPI({
    type: "GET",
    url: "/authprofile/getPrivacypolicy",
    data: data,
  });

  return result;
};

export const sendEmailPayment = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/sendEmailPayment",
    data: data,
  });

  return result;
};

export const uploadSlip = async (data) => {
  const result = await ProviderAPI({
    type: "POST",
    url: "/authprofile/uploadSlip",
    data: data,
  });

  return result;
};
